import { useMutation } from 'react-query'

import { deleteTicket } from '../../endpoints/tickets'

export const useDeleteTicket = () => {
    return useMutation(async (id: string) => await deleteTicket(id))
}
